<app-loading [show]="(!question || loading) && !error"></app-loading>
<ng-container *ngIf="question && !loading && !error">
    <app-progress-bar progressValue='100'></app-progress-bar>
    <app-category-title [title]="category.title"></app-category-title>
    
    <form class="text-center" #form="ngForm">
        <div class="form-group my-2 main">
            <app-observation-box [label]="question.legend"
                                 [(ngModel)]="finalComments"
                                 name="finalComments">
            </app-observation-box>
        </div>
    
        
        <div class="form-group">
            <app-custom-button label="Atras"
                               button_style="simple"
                               [newRoute]="['encuesta']"
                               class="mr-5">
            </app-custom-button>
            <app-custom-button label="Finalizar"
                               button_style="outline"
                               (click)="saveChanges()">
            </app-custom-button>
        </div>
    </form>
</ng-container>

<ng-container *ngIf="error">
    <app-custom-error message="Ha ocurrido un error al procesar sus respuestas.">
    </app-custom-error>    
</ng-container>